const local = 'http://localhost:3001';
// const api = 'https://leboncoin-alex-api.herokuapp.com';

const domain = local;

module.exports = domain;
